const config = {
    baseUrl: "https://www.letale.cn",
    fileUrl: "https://www.letale.cn",
    path: "https://www.letale.cn",
    videoPass: {
        "218.14.217.5": {
            username: "admin",
            password: "ltny123456"
        },
        "116.28.204.36": {
            username: "admin",
            password: "Lt@12345678"
        }
    }
};
export default config;



// WEBPACK FOOTER //
// ./src/window.js